import {useForm} from 'react-hook-form'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import FormWrapper from '../../shared/FormWrapper'
import SelectInput from '../../shared/SelectInput'
import Input from '../../shared/Input'

const NewVersion = props => {
  const methods = useForm()
  const {errors} = methods.formState

  return (
    <Stack className='new-version'>
      <FormWrapper methods={methods} handleSubmit={props.handleSubmit}>
        <Input
          error={!!errors.name}
          label='Name'
          name='name'
          options={{required: 'Name is required'}}
          helperText={errors.name?.message}
          margin='dense'
        />
        <Input
          error={!!errors.description}
          label='Description'
          name='description'
          options={{required: 'Description is required'}}
          helperText={errors.description?.message}
          type='textarea'
          multiline
          rows={4}
          margin='dense'
        />
        <SelectInput
          error={!!errors.sourceVersionId}
          label='Source Version'
          name='sourceVersionId'
          options={{required: 'Source Version is required'}}
          helperText={errors.sourceVersionId?.message}
          items={props.versions?.map(version => ({label: version.name, value: version.id}))}
          margin='dense'
        />
        <Button
          disabled={props.loading}
          type='submit'
          variant='contained'
          sx={{color: '#F7F7F7'}}>
          Submit
        </Button>
      </FormWrapper>
    </Stack>
  )
}

export default NewVersion
